import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';

export default function Login() {
  const { login } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(username, password);
    } catch (err) {
      setError(err.response?.data?.error || 'เกิดข้อผิดพลาด กรุณาลองใหม่');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(160deg, #f2f5ff 0%, #fafaf9 50%, #fff5f7 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}>
      {/* Glow blobs */}
      <div style={{ position:'fixed', top:-100, left:-100, width:400, height:400, background:'radial-gradient(circle, rgba(37,99,235,.07) 0%, transparent 70%)', pointerEvents:'none' }}/>
      <div style={{ position:'fixed', bottom:-80, right:-80, width:360, height:360, background:'radial-gradient(circle, rgba(236,72,153,.06) 0%, transparent 70%)', pointerEvents:'none' }}/>

      <div style={{
        width: 360,
        background: '#fff',
        border: '1px solid #ede9e3',
        borderRadius: 20,
        padding: '36px 32px',
        boxShadow: '0 4px 24px rgba(0,0,0,.08), 0 1px 2px rgba(0,0,0,.04)',
        position: 'relative',
        zIndex: 1,
      }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <div style={{
            width: 48, height: 48, borderRadius: 14,
            background: 'linear-gradient(135deg, #2563eb, #7c3aed)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            margin: '0 auto 12px',
            boxShadow: '0 4px 14px rgba(37,99,235,.25)',
          }}>
            <i className="ti ti-droplet" style={{ color: '#fff', fontSize: 22 }}/>
          </div>
          <div style={{ fontSize: 18, fontWeight: 700, color: '#111', letterSpacing: '-.4px' }}>Noirola BOM</div>
          <div style={{ fontSize: 11, color: '#aaa', marginTop: 3, letterSpacing: '.04em' }}>perfume manufacturing system</div>
        </div>

        {error && (
          <div style={{
            background: '#fef2f2', border: '1px solid #fecaca',
            borderRadius: 8, padding: '8px 12px',
            fontSize: 12, color: '#991b1b',
            marginBottom: 14, display: 'flex', alignItems: 'center', gap: 6,
          }}>
            <i className="ti ti-alert-circle" style={{ fontSize: 14 }}/>
            {error}
          </div>
        )}

        <form onSubmit={handleLogin}>
          <div className="form-group">
            <label className="fl">Username</label>
            <div style={{ position: 'relative' }}>
              <i className="ti ti-user" style={{
                position: 'absolute', left: 10, top: '50%', transform: 'translateY(-50%)',
                fontSize: 14, color: '#ccc', pointerEvents: 'none',
              }}/>
              <input
                className="fi"
                style={{ paddingLeft: 32 }}
                type="text"
                placeholder="กรอก username"
                value={username}
                onChange={e => setUsername(e.target.value)}
                autoFocus
              />
            </div>
          </div>

          <div className="form-group">
            <label className="fl">Password</label>
            <div style={{ position: 'relative' }}>
              <i className="ti ti-lock" style={{
                position: 'absolute', left: 10, top: '50%', transform: 'translateY(-50%)',
                fontSize: 14, color: '#ccc', pointerEvents: 'none',
              }}/>
              <input
                className="fi"
                style={{ paddingLeft: 32 }}
                type="password"
                placeholder="กรอก password"
                value={password}
                onChange={e => setPassword(e.target.value)}
              />
            </div>
          </div>

          <button
            type="submit"
            className="btn-primary"
            style={{ width: '100%', padding: '10px', marginTop: 6, fontSize: 13 }}
            disabled={loading}
          >
            {loading ? 'กำลังเข้าสู่ระบบ...' : 'เข้าสู่ระบบ'}
          </button>
        </form>

        <div style={{ textAlign: 'center', fontSize: 10, color: '#ddd', marginTop: 20 }}>
          Noirola Thailand · ระบบจัดการการผลิตน้ำหอม
        </div>
      </div>
    </div>
  );
}
